// import { useContext } from "react";

// import { AbilityContext } from "@metronic/_context/Can";

function useAbilitiesHelper(ability) {
  // const ability = useContext(AbilityContext);
  const isUserAllowed = (permissions, moduleName) => {

    let permissionCheck = permissions;
    let module = moduleName || permissions.MODULE_NAME;

    if (typeof permissions === 'string') {
      permissionCheck = { perm: permissions };
    }

    return Object.keys(permissionCheck).some(key => {
      return ability.can(permissionCheck[key], module)
    });
  }

  return [isUserAllowed];
}

export default useAbilitiesHelper;